module.exports = __webpack_public_path__ + "static/media/log_icon.ab72ddbe.png";